import { useState } from 'react';
import {
  IconSelectedCircle,
  IconCalendar,
  IconSettings,
  IconClose,
  ClickOutsideDetector,
  Rangepicker,
  DatePickerMode,
} from '@ui/src';
import { NotificationItemIssueStatus } from '../../hoc/center/types';
import { ControlsPanelTypes } from './types';

import cn from './styles.module.css';

const ControlsPanel = ({
  selectedNotifications,
  onSelectedAll,
  notificationsLength,
  setEditSidepanelVisible,
  setSelectedStatus,
  onClose,
  onSubmit,
  setStatusChangeNotificationVisible,
  setSelectedDeadline,
}: ControlsPanelTypes) => {
  const [statusMenuVisible, setStatusMenuVisible] = useState(false);
  const [deadlinePickerVisible, setDeadlinePickerVisible] = useState(false);
  const [deadlineValue, setDeadlineValue] = useState('');

  return (
    <div className={cn.notificationsControlPanel}>
      <div
        className={cn.selectedCount}
      >{`${selectedNotifications?.length} selected:`}</div>
      <button
        type="button"
        onClick={onSelectedAll}
        className={cn.selectedAllButton}
      >
        {notificationsLength !== selectedNotifications?.length
          ? 'Select all'
          : 'Clear all'}
      </button>
      <div className={cn.separator} />
      <div className={cn.changeStatusWrapper}>
        <ClickOutsideDetector setOptionsListVisible={setStatusMenuVisible}>
          <>
            <button
              type="button"
              className={`${cn.changeStatusButton} ${
                statusMenuVisible ? cn.active : ''
              }`}
              onClick={() => setStatusMenuVisible(!statusMenuVisible)}
            >
              <IconSelectedCircle />
              Change status
            </button>
            {statusMenuVisible && (
              <div className={cn.changeStatusList}>
                {[
                  {
                    name: `${NotificationItemIssueStatus.TODO.charAt(
                      0,
                    )}${NotificationItemIssueStatus.TODO.slice(
                      1,
                    ).toLowerCase()}`,
                    value: NotificationItemIssueStatus.TODO,
                  },
                  {
                    name: NotificationItemIssueStatus.IN_PROGRESS.split('_')
                      .map(
                        (item) =>
                          `${item.charAt(0)}${item.slice(1).toLowerCase()}`,
                      )
                      .join(' '),
                    value: NotificationItemIssueStatus.IN_PROGRESS,
                  },
                  {
                    name: `${NotificationItemIssueStatus.DONE.charAt(
                      0,
                    )}${NotificationItemIssueStatus.DONE.slice(
                      1,
                    ).toLowerCase()}`,
                    value: NotificationItemIssueStatus.DONE,
                  },
                  {
                    name: `${NotificationItemIssueStatus.CANCELED.charAt(
                      0,
                    )}${NotificationItemIssueStatus.CANCELED.slice(
                      1,
                    ).toLowerCase()}`,
                    value: NotificationItemIssueStatus.CANCELED,
                  },
                ].map((item) => (
                  <button
                    type="button"
                    className={cn.changeStatusListButton}
                    onClick={() => {
                      setStatusMenuVisible(false);
                      setSelectedStatus(item.name);

                      if (setStatusChangeNotificationVisible) {
                        setStatusChangeNotificationVisible(true);
                      }

                      if (onSubmit) {
                        onSubmit({
                          name: 'status',
                          value: item.value,
                        });
                      }
                    }}
                    key={item.value}
                  >
                    {item.name}
                  </button>
                ))}
              </div>
            )}
          </>
        </ClickOutsideDetector>
      </div>
      <div className={cn.changeStatusWrapper}>
        <ClickOutsideDetector setOptionsListVisible={setDeadlinePickerVisible}>
          <>
            <button
              type="button"
              className={`${cn.changeStatusButton} ${cn.deadlinePicker} ${
                deadlinePickerVisible ? cn.active : ''
              }`}
              onClick={() => setDeadlinePickerVisible(!deadlinePickerVisible)}
            >
              <IconCalendar width={16} height={16} />
              Deadline
            </button>
            {deadlinePickerVisible && (
              <div className={cn.deadlinePickerWrapper}>
                <Rangepicker
                  startDate={new Date()}
                  endDate={new Date(2099, 0, 1)}
                  onSingleApply={(date) => {
                    setDeadlineValue(date.toISOString());
                    setSelectedDeadline(date.toISOString());
                    setDeadlinePickerVisible(false);

                    if (onSubmit) {
                      onSubmit({
                        name: 'deadline',
                        value: date.toISOString(),
                      });
                    }
                  }}
                  mode={DatePickerMode.SINGLE}
                  value={deadlineValue ? [deadlineValue] : []}
                  onReset={() => setDeadlineValue('')}
                  withoutCustomSelector
                />
              </div>
            )}
          </>
        </ClickOutsideDetector>
      </div>
      <div className={cn.changeStatusWrapper}>
        <button
          type="button"
          className={`${cn.changeStatusButton} ${cn.otherSettings}`}
          onClick={() => setEditSidepanelVisible(true)}
        >
          <IconSettings width={16} height={16} />
          Other
        </button>
      </div>
      <div className={cn.changeStatusWrapper}>
        <button
          type="button"
          className={`${cn.changeStatusButton} ${cn.closeButton}`}
          aria-label="Close button"
          onClick={() => onClose()}
        >
          <IconClose width={16} height={16} />
        </button>
      </div>
    </div>
  );
};

export default ControlsPanel;
